// extracted by mini-css-extract-plugin
module.exports = {"urlsEmailSend":"FindMyWorkspacePage_urlsEmailSend__364O_"};